import React from 'react'
import { injectIntl } from 'react-intl'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { compose } from '../../../util'
import { AddNewSensorButton } from '../../../components/add-sensor-wizard/add-new-button'
import {
  getSelectSensorWizardRoute,
  updateRoute
} from '../../../components/route'

export function Bridge({ organizationId }) {
  return (
    <AddNewSensorButton
      data-e2e="add-source-button"
      onClick={() => updateRoute(getSelectSensorWizardRoute(organizationId))}
    />
  )
}

export const reactAddNewSensorButton = createNgReactBridgeDirective(
  'reactAddNewSensorButton',
  [],
  compose(injectIntl)(Bridge),
  ['organizationId']
)
